import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorTitle: {
		id: 'servicedesk-sla-settings.metrics.summary-with-actions.delete-metric-modal.flags.error-title',
		defaultMessage: 'Problem deleting metric',
		description: 'Title for delete error message.',
	},
	errorDescription: {
		id: 'servicedesk-sla-settings.metrics.summary-with-actions.delete-metric-modal.flags.error-description',
		defaultMessage: "{metricName} couldn't be deleted. Please check your internet connection.",
		description: 'Body for delete error message.',
	},
});
